import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { Response } from "@angular/http/src/static_response";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { CommonService } from "../../../../../views/services/common.service";
import { HeaderService } from "../../../../../views/services/header.service";
import {
  OrgModel,
  TranferStudentService
} from "../../service/transfer-student.service";
import { Country } from "../models/country";
import { Request } from "../models/request";
import { ZipCode } from "../models/zipcode";
import { PaperStepperComponent } from "../stepper/paper-stepper.component";
import { PaperExamineeRequestService } from "./paper-examinee-request.service";
import { PaperExamineeForm } from "./paper-examinee.form";

@Component({
  selector: "app-paper-examinee",
  templateUrl: "./paper-examinee.component.html",
  styleUrls: ["./paper-examinee.component.css"]
})
export class PaperExamineeComponent implements OnInit {
  public sasId: string;
  public aId: string;
  public tPin: string;
  public isInvalidActId: boolean = false;
  frmExamine: FormGroup;
  public organization: any;
  formSubmitted = false;
  isNational = false;
  isInternational = false;
  countries: Country[];
  zips: ZipCode[];
  recordCount = "0";
  public OrgMdmId: any;
  public OrgDetails: any;
  public orgData = [];
  public date: any;
  public selectedCountry: string = "";
  public selectedState: string = "";
  public selectedCity: string = "";
  public stateList: any = [];
  public cityList: any = [];
  public orgList: any = [];
  public orgModel: OrgModel;
  public displayOrgIdError: string = "";
  public searchFields: any = {};
  public searchOrg: any = {};
  public studentDetails: any;
  public countriesList: Country[];
  public Orgs: any;
  public orgFormSubmit: boolean = false;
  public orgError: string = "";

  @Input() savedRequest: Request;

  constructor(
    private examineeForm: PaperExamineeForm,
    private paperExamineeRequestService: PaperExamineeRequestService,
    private stepper: PaperStepperComponent,
    public headerService: HeaderService,
    private commonService: CommonService,
    public tranferStudentService: TranferStudentService
  ) {
    this.frmExamine = this.examineeForm.build();
  }
  ngOnInit() {
    if (sessionStorage.getItem("currentStudent")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("currentStudent")
      );
      this.savedRequest = studentDetails;
      this.paperExamineeRequestService.currentRequest = studentDetails;
    }
    Observable.forkJoin(
      this.paperExamineeRequestService.getCountries()
    ).subscribe(([data]) => {
      this.countriesList = data;
    });

    Observable.forkJoin(
      this.commonService.getDynContent("SASID"),
      this.commonService.getDynContent("ACTID"),
      this.commonService.getDynContent("TAA_PIN")
    ).subscribe(([sasId, aId, tPin]) => {
      this.sasId = sasId;
      this.aId = aId;
      this.tPin = tPin;
    });

    if (this.savedRequest) {
      Observable.forkJoin([
        this.paperExamineeRequestService.getCountries(),
        this.paperExamineeRequestService.getExamineeRequest(
          this.savedRequest.requestId
        ),
        this.paperExamineeRequestService.getPerson(this.savedRequest.personId),
        this.paperExamineeRequestService.getPersonName(
          this.savedRequest.personId
        ),
        this.paperExamineeRequestService.getPersonAddress(
          this.savedRequest.personId
        ),
        this.commonService.getFinishedRecordCount(this.savedRequest.personId),
        this.paperExamineeRequestService.getRequest(this.savedRequest.requestId)
      ]).subscribe(
        ([
          countries,
          request,
          person,
          personName,
          personAddress,
          finishedRecordCount,
          organization
        ]) => {
          this.countries = <Country[]>countries;
          const DOB = moment(
            person["body"][0]["BIRTH_DT"].substr(0, 10)
          ).format("L");

          const formValue = {
            StudentId: person["body"][0]["STATE_SYSTEM_ID"],
            ACTId: person["body"][0]["ACT_ID"],
            FirstName: personName["body"][0]["FIRST_NM"],
            MiddleName: personName["body"][0]["MIDDLE_NM"],
            LastName: personName["body"][0]["LAST_NM"],
            DOB: DOB,
            Country: personAddress["body"][0]["COUNTRY_CD"],
            Address1: personAddress["body"][0]["STREET_1_AD"],
            Address2: personAddress["body"][0]["STREET_2_AD"]
          };
          this.searchOrg = {};
          this.orgData = [];
          this.OrgMdmId = organization[0].ORG_MDM_ID;
          Observable.forkJoin(
            this.tranferStudentService.getOrgId(this.OrgMdmId),
            this.paperExamineeRequestService.lookupOrg(this.OrgMdmId)
          ).subscribe(([Org, lookupOrg]) => {
            this.OrgDetails = Org.body.data;
            this.OrgDetails.forEach(OrgDetail => {
              if (
                OrgDetail.keyType === "PARTY ID" &&
                (OrgDetail.keyValue && OrgDetail.statusCode === "A")
              ) {
                this.orgData.push(OrgDetail);
              }
            });
            this.organization = lookupOrg;
            this.countriesList.forEach(country => {
              if (lookupOrg[0].country === country.id) {
                this.frmExamine.controls["OrgCountry"].setValue(country);
                this.selectedCountry = this.frmExamine.controls["OrgCountry"]
                  .value
                  ? this.frmExamine.controls["OrgCountry"].value.id
                  : null;
                if (this.selectedCountry === "US") {
                  this.searchOrg.countryId = this.selectedCountry;
                  Observable.forkJoin(
                    this.tranferStudentService.getUsStateList()
                  ).subscribe(([result]) => {
                    this.stateList = result.body;
                    this.stateList.forEach(stateItem => {
                      if (lookupOrg[0].stateProvince === stateItem.code) {
                        this.frmExamine.controls["OrgState"].setValue(
                          stateItem
                        );
                        this.selectedState = this.frmExamine.controls[
                          "OrgState"
                        ].value
                          ? this.frmExamine.controls["OrgState"].value.code
                          : null;
                        Observable.forkJoin(
                          this.tranferStudentService.getUsCityList(
                            this.selectedState
                          )
                        ).subscribe(([usCityList]) => {
                          this.cityList = usCityList.body;
                          this.cityList.forEach(city => {
                            if (lookupOrg[0].city === city.city) {
                              this.frmExamine.controls["OrgCity"].setValue(
                                city
                              );
                              this.selectedCity = this.frmExamine.controls[
                                "OrgCity"
                              ].value
                                ? this.frmExamine.controls["OrgCity"].value.city
                                : null;

                              this.searchOrg.countryId = this.selectedCountry;
                              this.searchOrg.stateId = this.selectedState;
                              this.searchOrg.cityId = this.selectedCity;
                              Observable.forkJoin(
                                this.tranferStudentService.getOrganizationlist(
                                  this.searchOrg
                                )
                              ).subscribe(([cityList]) => {
                                this.orgList = cityList.body;
                                this.orgList.sort((a, b) =>
                                  a.organizationName > b.organizationName
                                    ? 1
                                    : -1
                                );
                                this.orgList.forEach(element => {
                                  if (
                                    lookupOrg[0].organizationName ===
                                    element.organizationName
                                  ) {
                                    if (element.organizationName) {
                                      element.displayOrgName =
                                        element.organizationName;
                                    }
                                    if (element.addrLine1) {
                                      element.displayOrgName +=
                                        "," + element.addrLine1;
                                    }
                                    if (element.addrLine2) {
                                      element.displayOrgName +=
                                        "," + element.addrLine2;
                                    }
                                    if (element.addrLine3) {
                                      element.displayOrgName +=
                                        "," + element.addrLine3;
                                    }
                                    if (element.addrLine4) {
                                      element.displayOrgName +=
                                        "," + element.addrLine4;
                                    }
                                    if (element.city) {
                                      element.displayOrgName +=
                                        "," + element.city;
                                    }
                                    if (element.stateProvince) {
                                      element.displayOrgName +=
                                        "," + element.stateProvince;
                                    }
                                    if (this.selectedCountry !== "US") {
                                      element.displayOrgName +=
                                        "," + this.selectedCountry;
                                    }
                                    this.frmExamine.controls[
                                      "NewOrganization"
                                    ].setValue(element);
                                  }
                                });
                              });
                            }
                          });
                        });
                      }
                    });
                  });
                } else if (this.selectedCountry) {
                  this.searchOrg.countryId = this.selectedCountry;
                  Observable.forkJoin(
                    this.tranferStudentService.getOrganizationlist(
                      this.searchOrg
                    )
                  ).subscribe(([orgList]) => {
                    this.cityList = orgList.body;
                    this.cityList.forEach(city => {
                      if (lookupOrg[0].city === city.city) {
                        this.frmExamine.controls["OrgCity"].setValue(city);
                        this.selectedCity = this.frmExamine.controls["OrgCity"]
                          .value
                          ? this.frmExamine.controls["OrgCity"].value.city
                          : null;
                        this.searchOrg.cityId = this.selectedCity;
                        Observable.forkJoin(
                          this.tranferStudentService.getOrganizationlist(
                            this.searchOrg
                          )
                        ).subscribe(([result]) => {
                          this.orgList = result.body;
                          this.orgList.sort((a, b) =>
                            a.organizationName > b.organizationName ? 1 : -1
                          );
                          this.orgList.forEach(element => {
                            if (lookupOrg[0].mdmId === element.mdmId) {
                              if (element.organizationName) {
                                element.displayOrgName =
                                  element.organizationName;
                              }
                              if (element.addrLine1) {
                                element.displayOrgName +=
                                  "," + element.addrLine1;
                              }
                              if (element.addrLine2) {
                                element.displayOrgName +=
                                  "," + element.addrLine2;
                              }
                              if (element.addrLine3) {
                                element.displayOrgName +=
                                  "," + element.addrLine3;
                              }
                              if (element.addrLine4) {
                                element.displayOrgName +=
                                  "," + element.addrLine4;
                              }
                              if (element.city) {
                                element.displayOrgName += "," + element.city;
                              }
                              if (element.stateProvince) {
                                element.displayOrgName +=
                                  "," + element.stateProvince;
                              }
                              if (this.selectedCountry !== "US") {
                                element.displayOrgName +=
                                  "," + this.selectedCountry;
                              }
                              this.frmExamine.controls[
                                "NewOrganization"
                              ].setValue(element);
                            }
                          });
                        });
                      }
                    });
                  });
                }
              }
            });
          });

          const countryIndex = this.countries.findIndex(
            value => value.id === personAddress["body"][0]["COUNTRY_CD"]
          );
          if (countryIndex !== -1) {
            this.getCountrySelection(countryIndex + 1);
            if (this.isInternational) {
              formValue["InternationalZip"] =
                personAddress["body"][0]["ZIP_POSTAL_CD"];
              formValue["InternationalCity"] =
                personAddress["body"][0]["CITY_NM"];
            } else if (this.isNational) {
              formValue["NationalZip"] =
                personAddress["body"][0]["ZIP_POSTAL_CD"];
              formValue["NationalCity"] = personAddress["body"][0]["CITY_NM"];
              formValue["NationalState"] = personAddress["body"][0]["STATE_CD"];
              this.lookupZipCode(personAddress["body"][0]["ZIP_POSTAL_CD"]);
            }
          }
          this.frmExamine.patchValue(formValue);
          this.recordCount = finishedRecordCount as any;
          if (this.recordCount !== "0") {
            this.frmExamine.disable();
          }
        }
      );
    } else {
      this.paperExamineeRequestService.getCountries().subscribe(data => {
        this.countries = data;
      });
    }
  }

  saveExamineeData(proceed: boolean): void {
    this.formSubmitted = true;
    if (this.frmExamine.valid) {
      const newActId: string = this.frmExamine.get("ACTId").value;
      if (newActId) {
        this.frmExamine.controls["ACTId"].setValue(newActId.replace(/-/gi, ""));
      }
      const req = Object.assign(
        {},
        this.frmExamine.value,
        this.savedRequest || {}
      );
      this.paperExamineeRequestService.saveExamineeRequest(req).subscribe(
        (data: any) => {
          if (data) {
            data.activeIdx = data.activeIdx - 1;
            sessionStorage.setItem("currentStudent", JSON.stringify(data));
            sessionStorage.setItem("examineeSubmitted", "true");
            this.stepper.onRequestSave(data, proceed);
            this.formSubmitted = false;
          }
        },
        (res: Response) => {
          if (res.status === 422) {
            const error = res.json().error;
            const codes = Object.keys(error.details.codes);
            codes.forEach(code => {
              switch (code) {
                case "STATE_SYSTEM_ID":
                  this.frmExamine.controls["StudentId"].setErrors({
                    pattern: "is not valid"
                  });
                  break;
                case "ACT_ID":
                  this.frmExamine.setErrors({
                    invalidActIdPattern: "is not valid"
                  });
                  break;
                case "FIRST_NM":
                  this.frmExamine.controls["FirstName"].setErrors({
                    fnm: "is not valid"
                  });
                  break;
                case "MIDDLE_NM":
                  this.frmExamine.controls["MiddleName"].setErrors({
                    mnm: "is not valid"
                  });
                  break;
                case "LAST_NM":
                  this.frmExamine.controls["LastName"].setErrors({
                    lnm: "is not valid"
                  });
                  break;
                case "BIRTH_DT":
                  this.frmExamine.controls["DOB"].setErrors({
                    dob: "is not valid"
                  });
                  break;
                case "COUNTRY_CD":
                  this.frmExamine.controls["Country"].setErrors({
                    ccd: "is not valid"
                  });
                  break;
                case "STREET_1_AD":
                  this.frmExamine.controls["Address1"].setErrors({
                    sad: "is not valid"
                  });
                  break;
                case "STREET_2_AD":
                  this.frmExamine.controls["Address2"].setErrors({
                    sadd: "is not valid"
                  });
                  break;
                case "ZIP_POSTAL_CD":
                  this.frmExamine.controls["InternationalZip"]
                    ? this.frmExamine.controls["InternationalZip"].setErrors({
                      izip: "is not valid"
                    })
                    : this.frmExamine.controls["NationalZip"].setErrors({
                      zip: "is not valid"
                    });
                  break;
                case "STATE_CD":
                  this.frmExamine.controls["NationalState"].setErrors({
                    ste: "is not valid"
                  });
                  break;
                case "CITY_NM":
                  this.frmExamine.controls["InternationalCity"]
                    ? this.frmExamine.controls["InternationalCity"].setErrors({
                      city: "is not valid"
                    })
                    : this.frmExamine.controls["NationalCity"].setErrors({
                      cty: "is not valid"
                    });
                  break;
                case "ORGANIZATION_NM":
                  this.frmExamine.controls["NewOrganization"].setErrors({
                    orgnm: "is not valid"
                  });
                  break;
              }
            });
          }
        }
      );
    }
  }

  lookupZipCode(zipcode: string) {
    this.frmExamine.patchValue({
      NationalCity: "",
      NationalState: undefined
    });
    this.paperExamineeRequestService.lookupZipCode(zipcode).subscribe(zips => {
      this.zips = zips;
      this.zips.forEach(zip => {
        if (zip.preferredLastLineCityStateKey === zip.cityStateKey) {
          this.frmExamine.patchValue({
            NationalCity: zip.cityStateName,
            NationalState: zip.stateAbbrv
          });
        }
      });
    });
  }

  getCountrySelection(index) {
    if (index > 0) {
      index = index - 1;
      const value = this.countries[index].id;
      if (value === "US") {
        this.isNational = true;
        this.isInternational = false;
        this.frmExamine.get("NationalZip").setValidators([Validators.required]);
        this.frmExamine
          .get("NationalState")
          .setValidators([Validators.required]);
        this.frmExamine
          .get("NationalCity")
          .setValidators([Validators.required]);
        this.frmExamine.get("InternationalZip").setValidators([]);
        this.frmExamine.get("InternationalCity").setValidators([]);
      } else if (value) {
        this.isNational = false;
        this.isInternational = true;
        this.frmExamine.get("InternationalZip").setValidators([]);
        this.frmExamine
          .get("InternationalCity")
          .setValidators([Validators.required]);
        this.frmExamine.get("NationalZip").setValidators([]);
        this.frmExamine.get("NationalState").setValidators([]);
        this.frmExamine.get("NationalCity").setValidators([]);
      } else {
        this.isNational = false;
        this.isInternational = false;
      }
      this.frmExamine.patchValue({
        Address1: "",
        Address2: "",
        InternationalZip: "",
        InternationalCity: "",
        NationalZip: "",
        NationalState: "",
        NationalCity: ""
      });

      this.frmExamine.updateValueAndValidity();
    }
  }
  changeCountry(event) {
    this.orgFormSubmit = false;
    this.displayOrgIdError = "";
    this.searchFields = {};
    this.cityList = [];
    this.stateList = [];
    this.orgList = [];
    this.selectedCountry = this.frmExamine.controls["OrgCountry"].value
      ? this.frmExamine.controls["OrgCountry"].value.id
      : null;
    this.frmExamine.controls["OrgState"].reset(null);
    this.frmExamine.controls["OrgCity"].reset(null);
    this.frmExamine.controls["NewOrganization"].reset(null);
    if (this.selectedCountry === "US") {
      this.searchFields.countryId = this.selectedCountry;
      this.frmExamine.get("OrgState").setValidators([Validators.required]);
      Observable.forkJoin(
        this.tranferStudentService.getUsStateList()
      ).subscribe(([result]) => {
        this.stateList = result.body;
        this.stateList.sort((a, b) => (a.name > b.name ? 1 : -1));
      });
    } else if (this.selectedCountry) {
      this.searchFields.countryId = this.selectedCountry;
      Observable.forkJoin(
        this.tranferStudentService.getOrganizationlist(this.searchFields)
      ).subscribe(([result]) => {
        this.cityList = this.removeDuplicates(result.body);
        this.cityList.sort((a, b) => (a.city > b.city ? 1 : -1));
      });
    }
  }

  removeDuplicates(originalArray) {
    const newArray = [];
    const lookupObject = {};

    for (const i in originalArray) {
      if (originalArray[i]) {
        lookupObject[originalArray[i]["city"]] = originalArray[i];
      }
    }

    for (const i in lookupObject) {
      if (lookupObject[i]) {
        newArray.push(lookupObject[i]);
      }
    }

    return newArray;
  }

  changeState(event) {
    this.orgFormSubmit = false;
    this.displayOrgIdError = "";
    this.cityList = [];
    this.orgList = [];
    this.searchFields.city = "";
    this.searchFields.newOrganization = "";
    this.searchFields.stateId = this.frmExamine.controls["OrgState"].value
      ? this.frmExamine.controls["OrgState"].value.code
      : null;
    if (this.searchFields.stateId) {
      Observable.forkJoin(
        this.tranferStudentService.getUsCityList(this.searchFields.stateId)
      ).subscribe(([result]) => {
        this.cityList = result.body;
        this.cityList.sort((a, b) => (a.city > b.city ? 1 : -1));
      });
    }
  }
  changeCity(event) {
    this.orgFormSubmit = false;
    this.displayOrgIdError = "";
    this.orgList = [];
    this.searchFields.newOrganization = "";
    this.searchFields.cityId = this.frmExamine.controls["OrgCity"].value
      ? this.frmExamine.controls["OrgCity"].value.city
      : null;
    if (this.searchFields.cityId) {
      Observable.forkJoin(
        this.tranferStudentService.getOrganizationlist(this.searchFields)
      ).subscribe(([result]) => {
        this.orgList = result.body;
        this.orgList.sort((a, b) =>
          a.organizationName > b.organizationName ? 1 : -1
        );
        this.orgList.forEach(element => {
          if (element.organizationName) {
            element.displayOrgName = element.organizationName;
          }
          if (element.addrLine1) {
            element.displayOrgName += "," + element.addrLine1;
          }
          if (element.addrLine2) {
            element.displayOrgName += "," + element.addrLine2;
          }
          if (element.addrLine3) {
            element.displayOrgName += "," + element.addrLine3;
          }
          if (element.addrLine4) {
            element.displayOrgName += "," + element.addrLine4;
          }
          if (element.city) {
            element.displayOrgName += "," + element.city;
          }
          if (element.stateProvince) {
            element.displayOrgName += "," + element.stateProvince;
          }
          if (this.selectedCountry !== "US") {
            element.displayOrgName += "," + this.selectedCountry;
          }
        });
      });
    }
  }
  changeOrg(event) {
    this.orgError = "";
    this.orgFormSubmit = false;
    this.displayOrgIdError = "";
    this.searchFields.newOrganizationName = this.frmExamine.controls[
      "NewOrganization"
    ].value
      ? this.frmExamine.controls["NewOrganization"].value.displayOrgName
      : null;
    if (this.searchFields.newOrganizationName) {
      this.OrgMdmId = this.frmExamine.controls["NewOrganization"].value.mdmId;
      this.tranferStudentService.getOrgId(this.OrgMdmId).subscribe(resp => {
        let orgData: Array<any> = [];
        if (resp.body.data != null) {
          orgData = resp.body.data.filter(function (item) {
            return item.keyType === "PARTY ID" && item.statusCode === "A";
          });
          if (this.searchFields.cityId) {
            if (orgData.length === 1) {
              Object.assign(this.frmExamine.controls["NewOrganization"].value, {
                orgId: orgData[0].keyValue
              });
            } else if (orgData.length === 0) {
              this.orgError =
                this.searchFields.newOrganizationName +
                ", " +
                this.searchFields.cityId +
                ", " +
                this.searchFields.stateId +
                " is not in the TAA system yet. If the organization should be in TAA system please check back in 1 hour as we may not have processed the request yet. If the organization is not here when you check back, please contact ACT Customer Service Support at 877.789.2925.";
            } else {
              this.orgError =
                this.searchFields.newOrganizationName +
                ", " +
                this.searchFields.cityId +
                ", " +
                this.searchFields.stateId +
                " Multiple organizations are attached in the TAA system. In order to continue, please contact ACT Customer Service Support at 877.789.2925.";
            }
          }
        }
      });
    }
  }
  continue() {
    this.stepper.goToNextStep();
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/process-paper-request/examinee/paper-examinee.component.ts